import React from "react";
import PropTypes from "prop-types";
import CommonImageUploader from "./CommonImageUploader";

const CommonImageUploaderFile = ({ imgSrc, onFileChange, onRemoveImage, ...rest }) => {

  const handleChange = (base64, imageName, _editImage, file) => {
    if (onFileChange) {
      onFileChange(file, base64, imageName); // ← file is the raw File object
    }
  };

  return (
    <CommonImageUploader
      imgSrc={imgSrc}
      onImageChange={handleChange}
      onRemoveImage={onRemoveImage}
      {...rest}
    />
  );
};

CommonImageUploaderFile.propTypes = {
  imgSrc: PropTypes.string,
  onFileChange: PropTypes.func.isRequired,
  onRemoveImage: PropTypes.func,
};

export default CommonImageUploaderFile;